import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { Valence } from '@upright/common/model/types';
import { getImpactBarDataLabelId } from '@upright/test-ids/dom-elements';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { useImpactBarsLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { formatImpactScore } from '@upright/ui/common/upright/model/output/scores/net-impact-chart/value-formatter';
import styled from 'styled-components';

interface Props {
  impact: ImpactCategoryId;
  valence: Valence;
}

/**
 * Data label drawn inside the bar if the bar is long enough to have space for it
 */
export function ImpactBarInsideDataLabel(props: Props) {
  const context = useNetImpactLensContext();
  const layout = useImpactBarsLayout();

  if (!context) {
    return <></>;
  }
  const { formatters, scoreUnit = FinalImpactScoreType.RELATIVE, scoreReader } = context.options;
  const value = scoreReader.readScore(props.impact, undefined, undefined, props.valence);

  if (!value) {
    return <></>;
  }

  const margin = 4;
  const barArea = layout.impactBarArea(valenceToSide(props.valence), props.impact);

  const x = props.valence === Valence.POSITIVE ? barArea.x2 - margin : barArea.x1 + margin;
  const anchor = props.valence === Valence.POSITIVE ? 'end' : 'start';

  if (barArea.width < 25) {
    return <></>;
  }
  const testId = getImpactBarDataLabelId(props.impact, props.valence);

  const color = props.valence === Valence.POSITIVE ? BouColor.PLATFORM_TEXT_GRAY_DARK : BouColor.PLATFORM_TEXT_WHITE;
  return (
    <Text fill={color} x={x} textAnchor={anchor} y={barArea.cy} dy="0.35em" data-testid={testId}>
      {props.valence === Valence.POSITIVE ? '+' : '-'}
      {formatImpactScore(value, formatters, scoreUnit)}
    </Text>
  );
}

const Text = styled.text``;
